module.exports = __webpack_public_path__ + "static/jojo-9ae341bfc3f9a352734162e20de1138c.jpg";